import {getAllEntitiesApply, selectManyByPredicate, UIEntitiesRef} from '@ngneat/elf-entities';
import {select} from '@ngneat/elf';
import {invoicesStore} from '@store/invoices/invoices/invoices.store';
import {getInvoicesDataSource, postBillDataSource} from '@store/invoices/invoices/invoices.requests';

export class InvoicesQuery {
  store = invoicesStore;

  filters$ = this.store.pipe(select((state) => state.filters));
  sort$ = this.store.pipe(select((state) => state.sort));
  pagination$ = this.store.pipe(select((state) => state.tablePagination));

  invoices$ = getInvoicesDataSource.data$();
  selectedInvoices$ = this.store.pipe(
    selectManyByPredicate((billUi) => billUi.selected, {pluck: 'id', ref: UIEntitiesRef}),
  );

  postBill$ = postBillDataSource.data$();
  sumNoVatInCents$ = this.store.pipe(select(state => state.sumNoVatInCents));

  get totalRows() {
    return this.store.getValue().pagination.total;
  }

  get selectedBills() {
    return this.store.query(
      getAllEntitiesApply({
        mapEntity: (e) => e.id,
        filterEntity: (e) => e.selected,
        ref: UIEntitiesRef,
      })
    );
  }
}

export const invoicesQuery = new InvoicesQuery();
